import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistrationStep2Service {
  api = environment.customerApiUrl;
  dualAuthorization = false;
  transferDualAuthorization = true;
  userRole = null;
  leadType: Number;
  email = '';

  constructor(protected http: HttpClient) {
  }

  addCorporate(corporate: any): Observable<any> {
    return this.http.post<any>(`${this.api}/customer/update-client-account`, corporate);
  }
  public getAccountType(): Observable<any> {
    const url: string = this.api + '/customer/account-type';
    return this.http.get<any>(url);
  }

  public generateSDKToken(data: any): Observable<any> {
    return this.http.post<any>(`${this.api}/onfido/create-onfido-applicant`, data);
  }

  public checkDocumentOnfido(data: any): Observable<any> {
    return this.http.post<any>(`${this.api}/passfort/create-document-check`, data);
  }

  public getUserInfo(): Observable<any> {
    return this.http.get<any>(`${this.api}/customer/get-account-detail`);
  }

  public runProfileCheck(profileCheck: any): Observable<any> {
    return this.http.post(`${this.api}/passfort/runOnboardingPepAndSanction`, profileCheck);
  }

  public complianceRisk(): Observable<any> {
    return this.http.get(`${this.api}/customer/check-compliance-risk-band-if-banned`);
  }

  public saveSupportingDoc(fileData: File): Observable<any> {
    const formData = new FormData();
    formData.append('', fileData, fileData.name);
    return this.http.post(`${this.api}/customer/save-supporting-doc`, formData);
  }

  public uploadSupportingDocs(data: any): Observable<any> {
    return this.http.post(`${this.api}/customer/upload-supporting-docs`, data);
  }
}
